import { lazy, Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import { findGuideBySlug, pageComponentNameForSlug } from '../data/infoGuides';

// One lazy chunk per guide (code-split exactly like the old per-guide routes), discovered by
// filename convention instead of an import + <Route> per guide in App.jsx.
const guideLoaders = import.meta.glob('./info/*Page.jsx');
const lazyGuides = new Map();

function getGuideComponent(slug) {
  if (!lazyGuides.has(slug)) {
    const loader = guideLoaders[`./info/${pageComponentNameForSlug(slug)}.jsx`];
    lazyGuides.set(slug, loader ? lazy(loader) : null);
  }
  return lazyGuides.get(slug);
}

// Serves /info/:slug. A slug that is not a registered guide (typo, removed page) redirects to
// the /info hub rather than rendering an empty 200 page, which Google would treat as a soft 404.
export default function InfoGuideRoute() {
  const { slug } = useParams();
  const GuidePage = findGuideBySlug(slug) ? getGuideComponent(slug) : null;

  if (!GuidePage) return <Navigate to="/info" replace />;

  return (
    <Layout>
      <Suspense fallback={<div>טוען...</div>}>
        <GuidePage />
      </Suspense>
    </Layout>
  );
}
